import React from "react";
import PropTypes from "prop-types";
import "./SearchBar.css";

const SearchBar = ({
  value,
  onChange,
  label = "Search:",
  placeholder = "",
  className = "",
  inputClassName = "",
  onClear,
  showClear = true,
  onFocus,
  onBlur,
}) => {
  const hasValue = Boolean(value && String(value).length > 0);

  return (
    <div className={`res-searchbar ${className}`.trim()}>
      {label ? <span className="res-searchbar__label">{label}</span> : null}
      <div className="res-searchbar__inputWrap">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={placeholder}
          className={`res-searchbar__input ${inputClassName}`.trim()}
        />
        <i className="fa fa-search res-searchbar__searchIcon" aria-hidden="true" />
        {showClear && hasValue && (
          <button
            type="button"
            className="res-searchbar__clearBtn"
            onClick={() => (onClear ? onClear() : onChange(""))}
            title="Clear search"
            aria-label="Clear search"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  onClear: PropTypes.func,
  showClear: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default SearchBar;

